import { useLang, BRANDS, logoUrl } from "@/lib/i18n";
import { BrandLogo } from "./BrandLogo";

const ALL = Object.values(BRANDS).flat().filter(logoUrl);

export const BrandMarquee = () => {
  const { t } = useLang();
  return (
    <section data-testid="brand-marquee" className="pb-10 pt-4">
      <p className="mb-6 px-5 text-center text-xs font-bold uppercase tracking-[0.2em] text-slate-400">{t.marquee}</p>
      <div className="marquee-wrap relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_10%,#000_90%,transparent)]">
        <div className="marquee-track items-center gap-3">
          {[...ALL, ...ALL].map((b, i) => (
            <span key={i} title={b} className="group rounded-xl border border-white/10 bg-white/[0.03] px-6 py-3 transition-[border-color,background-color] duration-300 hover:border-[#2F7BFF]/50 hover:bg-[#2F7BFF]/10">
              <BrandLogo name={b} size="lg" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
